import { useMemo } from 'react';
import {
  FeatureFlags,
  generateFeatureFlags,
} from '../Util/generateFeatureFlags';

export function useFeatureFlags(): FeatureFlags {
  return useMemo(generateFeatureFlags, []);
}
